import React, { useEffect, useState } from 'react'

export default function RefundPhoneConfirmModal({
  open,
  title,
  description,
  order,
  actionText,
  submitting,
  onClose,
  onConfirm
}) {
  const [confirmPhone, setConfirmPhone] = useState('')

  useEffect(() => {
    if (open) {
      setConfirmPhone('')
    }
  }, [open])

  if (!open || !order) return null

  // 无手机号订单（设备用户）改用用户ID二次确认
  const hasPhone = !!String(order.phone || '').trim()

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <p className="mt-2 whitespace-pre-line text-sm text-gray-600">{description}</p>

        <div className="mt-4 rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-700">
          <div>订单号：{order.order_no || '-'}</div>
          <div>用户：{order.nickname || order.username || '-'}</div>
          <div>手机号：{order.phone || '-'}</div>
          {!hasPhone && <div>用户ID：{order.user_id ?? '-'}</div>}
        </div>

        <div className="mt-4">
          <label className="mb-2 block text-sm font-medium text-gray-700">
            {hasPhone ? '请输入用户手机号进行二次确认' : '请输入用户ID进行二次确认'}
          </label>
          <input
            type="text"
            value={confirmPhone}
            onChange={(e) => setConfirmPhone(e.target.value)}
            placeholder={hasPhone ? '请输入完整手机号' : '请输入完整用户ID'}
            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 outline-none focus:border-red-500 focus:ring-2 focus:ring-red-100"
            autoFocus
          />
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={submitting}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            取消
          </button>
          <button
            type="button"
            onClick={() => onConfirm(confirmPhone)}
            disabled={submitting || !confirmPhone.trim()}
            className="rounded-lg bg-red-600 px-4 py-2 text-sm text-white hover:bg-red-700 disabled:opacity-50"
          >
            {submitting ? '处理中...' : actionText}
          </button>
        </div>
      </div>
    </div>
  )
}
